import axios from 'axios';

import { AsyncStorage } from 'services';
import { apiEndpoints } from 'helpers/endpoints';

export const getIntegrationToken = async () => {
  const accessToken = await AsyncStorage.get('accessToken');
  const organizationId = await AsyncStorage.get('organizationId');

  const headers = {
    headers: {
      'Content-Type': 'application/json',
      'FYI-Organization': organizationId,
      'FYI-Authorization': `Bearer ${accessToken}`,
    },
  };

  return axios
    .post(apiEndpoints.integrationsToken, null, headers)
    .then((response) => {
      const token = response.data.integration_token;

      return token;
    })
    .catch((error) => {
      return false;
    });
};

export const generateIntegrationOAuthUrl = (
  integrationToken: string,
  integrationUrl: string,
  path: string,
  userID: string,
  organizationId: string
) => {
  return [
    apiEndpoints.integrationsStart,
    `?integration_token=${integrationToken}`,
    `&integration_url=${integrationUrl}`,
    `&action=initiate_integration`,
    `&path=${path}`,
    `&userID=${userID}`,
    `&organizationID=${organizationId}`,
  ].join('');
};

/**
 * Parses an array of integrations and returns a new array
 * with the integrations that share the same type grouped together.
 * Returns an array of arrays of UserIntegrations
 * @param integrations
 */
export const groupIntegrations = (integrations: UserIntegration[]): UserIntegration[][] => {
  const grouped: UserIntegration[][] = [];

  integrations.forEach((userIntegration) => {
    let found;

    grouped.forEach((integrationGroup) => {
      found = integrationGroup.find((integration) => userIntegration.type === integration.type);

      if (found) {
        integrationGroup.push(userIntegration);
      }
    });

    if (!found) {
      grouped.push([userIntegration]);
    }
  });

  return grouped;
};
